<template>
  <div>
    <v-dialog v-model="showDialogMessage" width="700">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{
          getString("Messaggio")
        }}</v-card-title>
        <!-- eslint-disable vue/no-v-text-v-html-on-component -->
        <v-card-text v-html="currentMessage">
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="q-orange"
            flat
            @click.native="
              () => {
                showDialogMessage = false;
              }
            "
            >{{ getString("Chiudi") }}</v-btn
          >
        </v-card-actions>
        
      </v-card>
    </v-dialog>

    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-layout column v-if="shopLoad" align-center>
          <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
          <progress-q></progress-q>
        </v-layout>
        <modal-q v-if="loading"></modal-q>
        <!-- <v-progress-circular style="margin-top:100px" color="red lighten-3" size="64" indeterminate></v-progress-circular> -->
      </v-flex>

      <v-flex xs12 sm12 md12 lg6 v-if="!shopLoad">
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Gestisci i giorni di chiusura")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-layout row wrap>
              <!-- <v-flex xs12>
                <h3>{{getString('Inserisci un nuovo giorno di chiusura')}}</h3>
                <v-menu ref="dp3" :close-on-content-click="false" v-model="dp3" :nudge-right="40"
                  :return-value.sync="date" lazy transition="scale-transition" offset-y full-width min-width="290px">
                  <v-text-field slot="activator" v-model="date" :label="getString('Da')" prepend-icon="event" readonly
                    color="red lighten-2"></v-text-field>
                  <v-date-picker :locale="locale" :title-date-format="formatTitle" show-current color="red lighten-2"
                    v-model="date" @input="$refs.dp3.save(date)"></v-date-picker>
                </v-menu>
              </v-flex> -->
              <!-- <v-flex xs6>
                <v-btn @click="addDay" class="q-orange-bk q-text-whitesmoke">{{getString('Aggiungi giorno')}}</v-btn>
              </v-flex> -->
              <v-flex xs12>
                <h3>
                  {{
                    getString("Inserisci un intervallo di giorni di chiusura")
                  }}
                </h3>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  ref="dp1"
                  :close-on-content-click="false"
                  v-model="dp1"
                  :nudge-right="40"
                  :return-value.sync="dateStart"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateStart"
                    :label="getString('Da')"
                    prepend-icon="event"
                    readonly
                    color="red lighten-2"
                  ></v-text-field>
                  <v-date-picker
                    :locale="locale"
                    :title-date-format="formatTitle"
                    show-current
                    color="red lighten-2"
                    v-model="dateStart"
                    @input="$refs.dp1.save(dateStart)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-menu
                  ref="dp2"
                  :close-on-content-click="false"
                  v-model="dp2"
                  :nudge-right="40"
                  :return-value.sync="dateEnd"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateEnd"
                    :label="getString('A')"
                    prepend-icon="event"
                    readonly
                    color="red lighten-2"
                  ></v-text-field>
                  <v-date-picker
                    :locale="locale"
                    :title-date-format="formatTitle"
                    show-current
                    color="red lighten-2"
                    v-model="dateEnd"
                    @input="$refs.dp2.save(dateEnd)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <h3>
                  {{
                    getString(
                      "Inserisci un eventuale messaggio da comunicare ai tuoi clienti del motivo del perchè sei chiuso, oppure lascia vuoto."
                    )
                  }}
                </h3>
                <label>{{ getString("Messaggio") }}</label>
                <editor
                  style="background-color: red"
                  api-key="vn43j4ndioj2ysq09jicr7yfha8fvqcp8kye03mrgsixspv4"
                  v-bind:label="getString('Messaggio da comunicare')"
                  v-model="message"
                  :init="{
                    selector: 'textarea',
                    language_url: '../../static/languages/tinymce/it.js',
                    menubar: false,
                    min_height: 300,
                    branding: false,
                  }"
                ></editor>
              </v-flex>
              <v-flex xs12 class="center">
                <v-btn @click="addDays" class="q-orange-bk q-text-whitesmoke"
                  >{{ getString("Aggiungi intervallo") }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm12 md12 lg6 v-if="!shopLoad">
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-toolbar-title>{{
              getString("Lista dei giorni di chiusura")
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :headers="Headers"
              :items="closeDays"
              item-key="idIsBarberShopClosed"
              :rows-per-page-items="[10, 20, 30]"
              :rows-per-page-text="getString('Date per pagina')"
              :no-data-text="getString('Dati non disponibili')"
              class="elevation-0"
            >
              <template slot="items" slot-scope="props">
                <tr
                  style="max-height: 100px; overflow: hidden; cursor: pointer"
                >
                  <td class="text-xs-left">
                    {{ getFormattedDate(props.item.date) }}
                  </td>
                  <td class="text-xs-center">
                    <v-btn flat @click="deleteShopDay(props.item)">
                      <v-icon>remove_circle</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-xs-center">
                    <v-btn
                      flat
                      @click="showPopupMessage(props.item.message)"
                      v-if="props.item.message"
                    >
                      <v-icon>insert_drive_file </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Utils from "../../../utils.js";
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import Moment from "moment";
import ModalQ from "../../utils/ModalQ";
import Editor from "@tinymce/tinymce-vue";

var ut = new Utils();
export default {
  name: "ShopClosing",
  props: ["shopID", "tab"],
  components: {
    ProgressQ,
    ModalQ,
    editor: Editor,
  },
  mounted: function () {
    this.getShopTimes();
    this.getShopDays();
  },
  computed: {
    locale: function () {
      return this.$store.state.currentTranslator.locale;
    },
    pwdConfirmRule: function () {
      return [
        (v) => v === this.pwd || this.getString("Le password non coincidono"),
      ];
    },
    minLenghtRule: function () {
      return [
        (v) =>
          ut.MinLengthValidate(v, 8) ||
          this.getString("Password troppo corta, almeno 8 caratteri"),
      ];
    },
    notEmpty: function () {
      return [(v) => !!v || this.getString("Campo richiesto")];
    },
    urlRule: function () {
      return [(v) => ut.validateUrl(v) || this.getString("Url non valido")];
    },
    emailRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateEmail(v) || this.getString("Email non valida"),
      ];
    },
    numRule: function () {
      return [
        (v) => !!v || this.getString("Campo richiesto"),
        (v) => ut.ValidateNumber(v) || this.getString("Numero non valido"),
      ];
    },
    saveAlert: function () {
      return true;
    },
    defaultAvatar: function () {
      if (
        this.shop.imageLink === null ||
        this.shop.imageLink === "/images/shopdefault.png" ||
        this.shop.imageLink === "images/shopdefault.png"
      ) {
        return "../../../static/img/shopdefault.png";
      } else return ajax.baseUrl() + this.shop.imageLink;
    },
    Headers: function () {
      let result = [];
      let self = this;
      if (this.closeDays.length > 0) {
        let temp = [self.getString("Giorno:date"), self.getString("Rimuovi"), self.getString("Messaggio")];
        temp.forEach((element) => {
          result.push({
            text: self.getString(element.split(":")[0]),
            align: element.split(":").length > 1 ? "left" : "center",
            sortable: element.split(":").length > 1,
            value: element.split(":")[1],
          });
        });
        return result;
      }
      return [];
    },
  },
  data: () => {
    return {
      h: null,
      loading: false,
      timeDialog: false,
      showDialogMessage: false,
      currentMessage: null,
      hidden: false,
      image: null,
      times: [],
      fileUploadProgress: 0,
      selected: null,
      days: [],
      closeDays: [],
      shopLoad: false,
      saveTimes: false,
      date: new Moment().format("YYYY-MM-DD"),
      dateStart: new Moment().format("YYYY-MM-DD"),
      dateEnd: new Moment().format("YYYY-MM-DD"),
      message: "",
      dp1: false,
      dp2: false,
      dp3: false,
      timepicker0: false,
      timepicker1: false,
      timepicker2: false,
      timepicker3: false,
    };
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.getShopTimes();
        this.getShopDays();
      }
    },
    dateStart(newValue) {
      // Quando il valore di dateStart viene modificato, assegna lo stesso valore a dateEnd
      this.dateEnd = newValue;
    },
  },
  methods: {
    getFormattedDate: function (d) {
      return new Moment(d).locale("it").format("dddd DD MMMM YYYY");
    },
    formatTitle: function (d) {
      var options = {
        weekday: "long",
      };
      return ut.Capitalize(new Date().toLocaleString(this.locale, options));
    },
    getDayName: function (day) {
      switch (day) {
        case 0:
          return this.getString("Domenica");
        case 1:
          return this.getString("Lunedì");
        case 2:
          return this.getString("Martedì");
        case 3:
          return this.getString("Mercoledì");
        case 4:
          return this.getString("Giovedì");
        case 5:
          return this.getString("Venerdì");
        case 6:
          return this.getString("Sabato");
      }
    },
    select: function (item) {
      this.selected = item;
      //this.timeDialog = true;
    },

    getString: function (key) {
      let page = this.$store.state.currentTranslator.getString(key);
      return page;
    },
    getShopDays: function () {
      let self = this;
      this.shopLoad = true;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/closedays",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.closeDays = response.data.data;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    addDay: function () {
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .post(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/closedays/" +
              self.date,
            {},
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.closeDays.push(response.data.data);
            self.$emit("siteAlertSuccess", self.getString("Giorno aggiunto"));
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    addDays: function () {
      this.loading = true;
      let self = this;
      if (self.shopID > 0) {
        ajax.axios
          .post(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/closedays/" +
              self.dateStart +
              "/to/" +
              self.dateEnd,
            { message: self.message },
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.closeDays = [];
            self.closeDays = response.data.data;
            self.$emit("siteAlertSuccess", self.getString("Giorni aggiunto"));
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);

            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          })
          .finally(function () {
            self.loading = false;
          });
      }
    },
    showPopupMessage: function (message) {
      this.currentMessage = message
      this.showDialogMessage = true;
      
    },
    deleteShopDay: function (item) {
      let self = this;
      this.loading = true;
      if (self.shopID > 0) {
        ajax.axios
          .delete(
            ajax.baseUrl() +
              "/admin/shops/shop/" +
              self.shopID +
              "/closedays/" +
              item.idIsBarberShopClosed,
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            let temp = [];
            self.$emit("siteAlertSuccess", response.data.data);
            for (let index = 0; index < self.closeDays.length; index++) {
              if (
                self.closeDays[index].idIsBarberShopClosed !==
                item.idIsBarberShopClosed
              ) {
                temp.push(self.closeDays[index]);
              }
            }
            self.closeDays = temp;
            self.loading = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);

            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    getShopTimes: function () {
      let self = this;
      this.shopLoad = true;
      if (self.shopID > 0) {
        ajax.axios
          .get(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/opentimes",
            {
              headers: self.$store.getters.tokenHeader,
              withCredentials: true,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            let temp = response.data.data;
            self.days = [];
            self.shopLoad = false;
            temp.forEach((element) => {
              let t = [];
              t[0] = element[0];
              t[1] = element[1];
              t[0].open = new Moment(element[0].open, "HH:mm:ss").format(
                "HH:mm"
              );
              t[0].close = new Moment(element[0].close, "HH:mm:ss").format(
                "HH:mm"
              );
              t[1].open = new Moment(element[1].open, "HH:mm:ss").format(
                "HH:mm"
              );
              t[1].close = new Moment(element[1].close, "HH:mm:ss").format(
                "HH:mm"
              );
              self.days.push({
                times: t,
                isOpen:
                  t[0].open !== "00:00" ||
                  t[0].close !== "00:00" ||
                  t[1].open !== "00:00" ||
                  t[1].close !== "00:00",
                isContinue:
                  element[0].open === element[1].open &&
                  element[0].close === element[1].close,
                isBookable: element[0].isBookable,
              });
            });
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      }
    },
    setShopTimes: function () {
      if (this.saveAlert) {
        let self = this;
        this.saveTimes = true;
        let data = this.days;
        ajax.axios
          .put(
            ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/opentimes",
            data,
            {
              headers: {
                Authorization: "Bearer " + self.$store.getters.token,
              },
              onUploadProgress: function (progressEvent) {
                let p = parseInt(
                  Math.round((progressEvent.loaded * 100) / progressEvent.total)
                );
                self.fileUploadProgress = p;
              }.bind(this),
              withCredentials: false,
            }
          )
          .then(function (response) {
            ajax.validateToken(response.headers, self.$store);
            self.$emit("siteAlertSuccess", response.data.data);
            self.saveTimes = false;
          })
          .catch(function (error) {
            var auth = ajax.checkAuth(error, self.$store, self.$router);
            self.saveTimes = false;
            self.$emit(
              "siteAlert",
              auth
                ? self.getString("Non hai l'autorizzazione")
                : error.response.data.errorMessage
            );
          });
      } else {
        this.$emit("siteAlert", this.getString("Nessuna modifica richiesta"));
      }
    },
  },
};
</script>

<style scoped>
.save-alert {
  animation-name: saveAlertAnimation !important;
  animation-timing-function: linear !important;
  animation-duration: 1s !important;
  animation-iteration-count: infinite !important;
}

@keyframes saveAlertAnimation {
  0% {
    background-color: transparent;
  }

  50% {
    background-color: bisque;
  }

  100% {
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopClosing.vue